import { getToken } from '@/utils/auth';
import { router } from '@/router';

// 登录页面

// 页面白名单
const whiteList = ['/login', '/register', '/huanYing','/wxAuthor', '/share', '/resetPwd',
  '/mine/baoDan/shouHouZhiYin', '/infoRegist','/infoRegistTuanCai', '/microstore/*',
  '/page/insuranceCardDetail','/page/insuranceCardOrder','/mine/quanyikaDetail/*',
  '/quanyika','/page/infomationInfo'];

// 辅助函数，用于检查路径是否匹配带有通配符的模式
function matchesPattern(path, pattern) {
  const regex = new RegExp('^' + pattern.replace('*', '.*') + '$');
  return regex.test(path);
}

// 检查URL是否在白名单中
function checkWhite(url) {
  const path = url.split('?')[0];
  return whiteList.some(pattern => matchesPattern(path, pattern));
}

// 页面跳转验证拦截器
router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }

  if (getToken()) {
    next();
  } else {
    if (checkWhite(to.path)) {
      next();
    } else {
      next({ path: '/login', query: { redirect: to.fullPath } });
    }
  }
});

router.afterEach((to, from) => {
  // 有主级到次级
  if (to.meta.index > from.meta.index) {
    to.meta.transition = 'slide-left'; // 向左滑动
  } else if (to.meta.index < from.meta.index) {
    // 由次级到主级
    to.meta.transition = 'slide-right';
  } else {
    to.meta.transition = null;   //同级无过渡效果
  }
});